import { Button, Flex, Menu } from 'antd';
import Sider from 'antd/es/layout/Sider';
import './index.scss';
import {Link, useLocation} from 'react-router-dom';
import { samplePagesConfigs } from "../../page/routerPage";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { BsBoxArrowInLeft, BsBoxArrowInRight } from "react-icons/bs";

const AppSidebar = () => {
    const [userRole, setUserRole] = useState(null);
    const [collapsed, setCollapsed] = useState(false);
    const [defaultKey, setDefaultKey] = useState('')
    const { data: { user } } = useSelector(state => state.auth);
const router=useLocation()
    useEffect(() => {
        if (user) {
            setUserRole(user?.role);
        }
    }, [user]);

    useEffect(() => {
        const pathname=router.pathname.split('/')[1]

        const defaultKey=samplePagesConfigs.filter(item=>item?.path.split('/')[1]===pathname&&!item?.path.split('/')[2])
        setDefaultKey(`${defaultKey[0]?.key}`)
    }, [router.pathname]);


    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 992) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isPermitted = (roles) => roles.some(role => userRole.includes(role));
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const menuItems = userRole ? samplePagesConfigs.filter(menu => isPermitted(menu.permittedRole) && !menu.noIndex).map((menu) => {
            if (menu.items) {
                return {
                    key: menu.key,
                    label: <LinkItem icon={menu.icon} label={menu.label} />,
                    children: menu.items
                        .filter(menuItem => isPermitted(menuItem.permittedRole) && !menuItem.noIndex)
                        .map((menuItem) => ({
                            key: menuItem.key,
                            label: (
                                <Link to={menuItem.path}>
                                    <LinkItem icon={menuItem.icon} label={menuItem.label} />
                                </Link>
                            ),
                        })),
                };
            }
            return {
                key: menu.key,
                label: (
                    <Link to={menu.path}>
                        <LinkItem icon={menu.icon} label={menu.label} />
                    </Link>
                ),
            };
        }) : [];
    return (
        <>
            <Sider
                width={300}
                collapsedWidth={60}
                breakpoint={'lg'}
                style={{ position: 'relative' }}
                collapsed={collapsed}
            >
                <Flex style={{ height: '100%' }} vertical={true} justify={"center"}>
                    <Menu
                        className="app-aside"
                        mode="inline"
                        items={menuItems}
                        selectedKeys={[defaultKey]}
                    />
                    <Button
                        icon={collapsed ? <BsBoxArrowInRight style={{ fontSize: 24, height: '100%' }} /> :
                            <BsBoxArrowInLeft style={{ fontSize: 24, height: '100%' }} />}
                        onClick={toggleCollapsed}
                        style={{ marginBottom: 16, width: '100%', border: 0 }}
                        variant="text"
                    >
                        {!collapsed && 'Закрыть '}
                    </Button>
                </Flex>
            </Sider>
        </>
    );
};

export default AppSidebar;

export const LinkItem = ({ icon, label }) => {
    return (
        <Flex gap={20}>
            <span>{icon}</span>
            {label && <span className="link-label">{label}</span>}
        </Flex>
    );
};
